let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5NmQj")).then(() => parcelRequire('3Hy6N'));